export default function DelUI() {
	let docUIs = document.querySelector('.lil-gui')
	if(docUIs) { docUIs.remove(); }
}